document.addEventListener('DOMContentLoaded', function () {
  const filterForm = document.querySelector('.filter-main-form');
  if (!filterForm) return;

  const fields = [
    { selectId: 'filter_year', errorId: 'year_error', msg: 'Please select a year' },
    { selectId: 'filter_make', errorId: 'make_error', msg: 'Please select a car make' },
    { selectId: 'filter_model', errorId: 'model_error', msg: 'Please select a model' }
  ];

  filterForm.addEventListener('submit', function (e) {
    let isValid = true;

    fields.forEach(f => {
      const select = document.getElementById(f.selectId);
      const error = document.getElementById(f.errorId);
      
      if (select && select.value === "") {
        error.textContent = f.msg;
        isValid = false;
      } else if (error) {
        error.textContent = "";
      }
    });

    if (!isValid) e.preventDefault();
  });

  fields.forEach(f => {
    const select = document.getElementById(f.selectId);
    const error = document.getElementById(f.errorId);

    if (select && error) {
      select.addEventListener('change', function() {
        if (this.value !== "") {
          error.textContent = ""; 
        }
      });
    }
  });

  document.addEventListener('click', function (e) {
    const isClickInsideForm = filterForm.contains(e.target);

    if (!isClickInsideForm) {
      fields.forEach(f => {
        const errorElement = document.getElementById(f.errorId);
        if (errorElement) errorElement.textContent = "";
      });
    }
  });
});

document.addEventListener('DOMContentLoaded', function() {
    const images = document.querySelectorAll('.product-image');
    const contents = document.querySelectorAll('.product-content');
    const nextBtn = document.getElementById('nextSlide');
    const prevBtn = document.getElementById('prevSlide');
    let currentIndex = 0;
    let isAnimating = false;

    function updateSlider(nextIndex) {
      if (isAnimating || currentIndex === nextIndex) return;
      isAnimating = true;

      const currentImg = images[currentIndex];
      const nextImg = images[nextIndex];
      const currentContent = contents[currentIndex];
      const nextContent = contents[nextIndex];

      currentImg.classList.add('sending-back');
      
      setTimeout(() => {
        currentImg.classList.remove('active', 'sending-back');
        currentContent.classList.remove('active');
        
        nextImg.classList.add('active');
        nextContent.classList.add('active');

        currentIndex = nextIndex;
        isAnimating = false;
      }, 400); 
    }

    nextBtn?.addEventListener('click', () => {
      updateSlider((currentIndex + 1) % images.length);
    });

    prevBtn?.addEventListener('click', () => {
      updateSlider((currentIndex - 1 + images.length) % images.length);
    });
});
  
  document.addEventListener('DOMContentLoaded', function () {
    const hotspots = document.querySelectorAll('.hotspot-wrapper');

    hotspots.forEach((wrapper) => {
      const btn = wrapper.querySelector('.hero-trigger-btn');
      const closeBtn = wrapper.querySelector('.js-close-hotspot');

      btn.addEventListener('click', function (e) {
        e.stopPropagation();

        document.querySelectorAll('.hero-trigger-btn').forEach(b => {
          if (b !== btn) b.classList.remove('is-active');
        });

        btn.classList.toggle('is-active');

        const section = btn.closest('.material-hero-section');
        if (btn.classList.contains('is-active')) {
          section.classList.add('hotspot-open');
        } else {
          section.classList.remove('hotspot-open');
        }
      });

      if (closeBtn) {
        closeBtn.addEventListener('click', function () {
          btn.classList.remove('is-active');
          const section = btn.closest('.material-hero-section');
          section.classList.remove('hotspot-open');
        });
      }
    });

    document.addEventListener('click', function () {
      document.querySelectorAll('.hero-trigger-btn').forEach(b => {
        b.classList.remove('is-active');
      });
      document.querySelectorAll('.material-hero-section').forEach(sec => {
        sec.classList.remove('hotspot-open');
      });
    });
  });

   document.addEventListener('DOMContentLoaded', () => {
  const animateCount = (el) => {
    const target = parseInt(el.getAttribute('data-target'));
    let count = 0;
    const duration = 2000; 
    const increment = target / (duration / 16);

    const updateCount = () => {
      count += increment;
      if (count < target) {
        el.innerText = Math.floor(count);
        requestAnimationFrame(updateCount);
      } else {
        el.innerText = target;
      }
    };

    updateCount();
  };

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const numbers = entry.target.querySelectorAll('.js-count-up');
        numbers.forEach(num => animateCount(num));
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.5 });

  const section = document.querySelector('.custom-stats');
  if (section) observer.observe(section);
   });
  
   /**
 * Google Review Swiper Initialization
 */
const initGoogleReviewSliders = () => {
  const sliders = document.querySelectorAll('.mySwiper');

  sliders.forEach((slider) => {
    const sectionId = slider.getAttribute('data-section-id');
    if (slider.classList.contains('swiper-initialized')) return;

    new Swiper(slider, {
      slidesPerView: 1,
      spaceBetween: 20,
      loop: false,
      navigation: {
        nextEl: `.swiper-button-next`,
        prevEl: `.swiper-button-prev`,
      },
      pagination: {
        el: `.swiper-pagination`,
        type: 'progressbar',
      },
      breakpoints: {
        768: { slidesPerView: 2 },
        1200: { slidesPerView: 3 },
      },
    });
  });
};

document.addEventListener('DOMContentLoaded', initGoogleReviewSliders);
document.addEventListener('shopify:section:load', (event) => {
  if (event.target.querySelector('.mySwiper')) {
    initGoogleReviewSliders();
  }
});


  document.addEventListener('DOMContentLoaded', function() {
    const swiper = new Swiper(".seriesmySwiper", {
      slidesPerView: 1,
      spaceBetween: 20,
      pagination: {
        el: ".swiper-pagination",
        type: "progressbar",
      },
      navigation: {
        nextEl: ".slider-nav-btn.next-btn",
        prevEl: ".slider-nav-btn.prev-btn",
      },
      breakpoints: {
        640: { slidesPerView: 2.2 },
        1024: { slidesPerView: 3.5 },
      },
    });
  });
  document.addEventListener('DOMContentLoaded', initGoogleReviewSliders);
document.addEventListener('shopify:section:load', (event) => {
  if (event.target.querySelector('.mySwiper')) {
    initGoogleReviewSliders();
  }
});


  document.addEventListener('DOMContentLoaded', function() {
    const swiper = new Swiper(".relatedmySwiper", {
      slidesPerView: 1,
      spaceBetween: 20,
      pagination: {
        el: ".swiper-pagination",
        type: "progressbar",
      },
      navigation: {
        nextEl: ".slider-nav-btn.next-btn",
        prevEl: ".slider-nav-btn.prev-btn",
      },
      breakpoints: {
        640: { slidesPerView: 2.2 },
        1024: { slidesPerView: 3.2 },
      },
    });
  });


  /**
 * Sticky Section Image Scrolling Logic
 * Handles the "Slide Out" effect for desktop and active states
 */
const initStickyImages = () => {
  const stickySections = document.querySelectorAll('[class*="sticky-section-"]');

  stickySections.forEach((section) => {
    const items = section.querySelectorAll(".sticky-item");
    const images = section.querySelectorAll(".sticky-img");

    if (!items.length || !images.length) return;

    const handleScroll = () => {
      let activeIndex = 0;
      const threshold = window.innerHeight / 2;

      items.forEach((item, i) => {
        const rect = item.getBoundingClientRect();
        if (rect.top < threshold) {
          activeIndex = i;
        }
      });

      images.forEach((img, i) => {
        img.classList.remove("active", "exit");

        if (i < activeIndex) {
          img.classList.add("exit");
        } else if (i === activeIndex) {
          img.classList.add("active");
        }
      });

      items.forEach((item, i) => {
        item.classList.toggle("active", i === activeIndex);
      });
    };

    window.addEventListener("scroll", handleScroll);
    handleScroll();
  });
};

document.addEventListener("DOMContentLoaded", initStickyImages);

if(document.querySelector(".sticky-action .luxus-btn")){
  document.querySelector(".sticky-action .luxus-btn").addEventListener('click', function(){
    let matc = document.querySelector('.product .product-form__submit');
    if(matc){
      matc.dispatchEvent(new Event('click'));
    }
  })
}

$(".sticky-action .luxus-btn").click(function(){
  if($(this).hasClass("custom-sticky-disabled")){
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
    return;
  }
  if($('.product .product-form__submit').length > 0){
    $('.product .product-form__submit').trigger("click");
    $(this).addClass("active");
  }
})